export var IQueryName;
(function (IQueryName) {
    IQueryName["SAVE_COOKIES"] = "save cookies";
})(IQueryName || (IQueryName = {}));
